import React from "react";
import { useNavigate } from "react-router";

const getLotteryTypeFromRoute = (route) => {
    return String(route?.path || "")
        .split("/")
        .filter(Boolean)
        .pop();
};

const HomePage = ({ routes, showResultButton = false }) => {
    const navigate = useNavigate()
    const firstLotteryType = getLotteryTypeFromRoute(routes?.[0]);

    return <div className="w-100 h-100">
        <div className="w-100 h-100 d-flex justify-content-center align-items-center" style={{
            backgroundImage: `url(${require(`../assets/images/live-v2/welcome/wel_bg.jpg`)})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100% 100%"

        }}>
            <div className="">
                <div className="d-flex justify-content-center">
                    <img src={require("../assets/images/live-v2/welcome/welcome.png")} alt="_wel" />
                </div>

                <div className="d-flex flex-wrap justify-content-around align-items-center mt-4">
                    {routes.map(({ name, path }) => {
                        return <button key={name} className="button-start mb-4 mx-3"
                            onClick={() => navigate(`${path}`)}>{name}
                        </button>
                    })}
                </div>
                {showResultButton && firstLotteryType && (
                    <div className="d-flex justify-content-center mt-2">
                        <button
                            type="button"
                            className="button-start mb-4 mx-3"
                            onClick={() => navigate(`/result/${firstLotteryType}`)}
                        >
                            Result
                        </button>
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default HomePage;
